var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconstag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.8,3a1.592,1.592,0,0,0-1.131.469l-7.2,7.2a1.6,1.6,0,0,0,0,2.263l1.25,1.25a3.161,3.161,0,0,1,.819-1.444l7.2-7.2A3.177,3.177,0,0,1,14,4.6h4.356A3.186,3.186,0,0,0,15.6,3ZM14,6.2a1.592,1.592,0,0,0-1.131.469l-7.2,7.2a1.6,1.6,0,0,0,0,2.263l6.4,6.4a1.6,1.6,0,0,0,2.263,0l7.2-7.2A1.592,1.592,0,0,0,22,14.2V9.4a3.2,3.2,0,0,0-3.2-3.2Zm4.8,1.6a1.6,1.6,0,1,1-1.6,1.6A1.6,1.6,0,0,1,18.8,7.8Z",
    transform: "translate(-2 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstag);
export default __webpack_public_path__ + "static/media/icons tag.8efbe68fc7cf84cf41b4fb264392e052.svg";
export { ForwardRef as ReactComponent };